import React, { useState } from 'react';
import emailjs from "emailjs-com";
import { useForm } from "react-hook-form";
import config from "../configur";
import txt from "../app-ads.txt"
import {Link} from 'react-scroll';

function Contact() {

    const [successMessage, setSuccessMessage] = useState("");
    const { register, handleSubmit, formState: { errors }} = useForm();

    const servicesID = config.servicesID;
    const templatID = config.templatID;
    const userID = config.userID;

    const onSubmit = (data, r) => {
        sendEmail(
            servicesID,
            templatID,
            {
                email: data.email,
                message: data.message
            },
            userID
            )
            r.target.reset()
    }

    const sendEmail = (servicesID, templatID, variables, userID) => {
        emailjs.send(servicesID, templatID, variables, userID)
          .then(() => {
            setSuccessMessage("Your message sent successfully! we'll contact you as soon as possible.")
          }).catch(err => console.error(`Something went wrong ${err}`));
      }

    return (
        <div id='contactus'>
            <h3>Contact Form</h3>
            <span className="success-message">{successMessage}</span>    
            <br/>
              
                {/* <div className="contactus-input"> */}
                {/* <input placeholder="Your Message" /> */}
                {/* </div> */}
                {/* <a href='#'>Continue</a> */}
                {/* <span>zviyemin@gmail.com</span> */}
                {/*  */}
                {/*  */}
            <p className="text-center">
            <span>support@zviyamin.com</span>
            </p>
                <p className="text-center">
              Copyright&copy;
              {new Date().getFullYear()}&nbsp;Zvi Yamin | All Rights Reserved
            </p>
            <br/>
            <p className="no-edit-cursor"><Link to='main' smooth={true} duration={1000}>HOME</Link></p>
        </div>
    )
}

export default Contact;
